<template>
	<div class="item">
		<router-link :to="$store.getters['main/getSingleUrl'](item)">
			<h3 class="ttl">{{ item.title }}</h3>
		</router-link>
		<div class="list">
			<div v-if="type?.length" class="list-item">
				<span>{{$fn.tr("ღონისძიების ტიპი:")}}</span>
				<span v-for="(item, index) in type" :key="item.id">
								{{ addComma(item.title, index, type.length) }}</span
							>
			</div>
			<div v-if="item.target_group" class="list-item">
				<span>{{ $fn.tr("სამიზნე ჯგუფი:") }}</span>
				<span>{{ item.target_group }}</span>
			</div>
			<div class="list-item">
				<span>{{ $fn.tr("ბენეფიციარების რაოდენობა:") }}</span>
				<span>{{ item.number_of_beneficiaries || 0 }}</span>
			</div>
			<div v-if="item?.event_date_from || item?.event_date_to" class="list-item">
				<span>
					{{ $fn.tr("ჩატარების თარიღი: ") }}
				</span>
				<span
					>{{ formatDate(item?.event_date_from) }}
					<template v-if="isOneDate">-</template>
					{{ formatDate(item?.event_date_to) }}</span>
			</div>
		</div>
	</div>
</template>
 
<script>
export default {
	props: {
		index: {
			type: Number,
		},
		item: {
			type: Object,
			default() {
				return {};
			},
		},
	},
	computed: {
		isDate() {
			return !!(this.item?.event_date_from || this.item?.event_date_to);
		},
		isOneDate() {
			return !!(this.item?.event_date_from && this.item?.event_date_to);
		},
		types() {
			return _.get(this.$store, "state.main.indx.terms.event_types");
		},
		type() {
			return this.types?.filter((item) =>
				this.item?.event_types?.includes(item.id)
			);
		},
	},
	methods: {
		formatDate(date) {
			if (!date) return "";
			return date.replace(/-/g, "/");
		},
		addComma(title, index, length) {
			if (length > 1 && index < length - 1) return title + ",";
			return title;
		},
	},
};
</script>

<style lang="scss" scoped>
.item {
	padding: 36px 8px;
	border-bottom: 1px solid #c8c9ca;
	display: flex;
	flex-direction: column;
}
.ttl {
	font-size: 21px;
	color: #0d1317;
	text-decoration: underline;
}
.teaser {
	font-size: 16px;
	color: #0d1317;
	margin-top: 24px;
	overflow: hidden;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2;
}
.bottom {
	padding-top: 24px;
	margin-top: auto;
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.btn {
	flex: none;
	display: inline-flex;
	padding: 12px 12px;
	background-color: #3a60a9;
	font-size: 21px;
	color: #fff;
	transition: 0.4s;

	&:hover {
		background-color: var(--secondarty-transparent);
	}
}
.date {
	padding-left: 32px;
	span {
		font-size: 18px;
		font-weight: 600;
	}
	span:first-child {
		color: #3a60a9;
		padding-right: 32px;
	}
}

.list{
	display: flex;
	flex-wrap: wrap;
	margin-top: 36px;
}

.list-item{
	width: 25%;
	display: flex;
	flex-direction: column;
	padding-left: 14px;
	border-left: 2px solid #B50700;
	padding-right: 16px;
}
span:first-child{
	font-size: 18px;
	color: #3A60A9;
	font-weight: 600;
}
span:last-child{
	display: inline-block;
	margin-top: 4px;
	font-size: 18px;
	color: #0D1317;
	font-weight: 600;
}
@media (max-width: 1599px){
	span:first-child,
	span:last-child{
		font-size: 16px;
	}
	.list-item{
		padding-left: 10px;
		padding-right: 12px;
	}
}
@media (max-width: 1280px){
	.list-item{
		width: 50%;
	}
	.list-item:nth-child(3){
		margin-top: 21px;
	}
	.list-item:nth-child(4){
		margin-top: 21px;
	}
}

@media (max-width: 1023px) {
	.list-item{
		width: 100%;
		margin-top: 16px !important;
	}
	.list-item:first-child{
		margin-top: 0 !important;
	}
	.item {
		padding: 21px 0;
	}
	.teaser {
		margin-top: 21px;
	}
	.ttl {
		font-size: 21px;
	}
	.bottom {
		padding-top: 21px;
	}
	.date {
		display: flex;
		flex-direction: column;
		span {
			font-size: 16px;
		}
		span:first-child {
			padding-right: 0;
		}
	}

	.btn {
		padding: 10px 21px;
		font-size: 16px;
	}
}
@media (max-width: 767px) {
	.ttl {
		font-size: 18px;
	}
	.teaser {
		font-size: 16px;
	}
	.bottom {
		flex-direction: column-reverse;
		align-items: flex-start;
		justify-content: flex-start;
	}
	.date {
		padding-left: 0;
		margin-bottom: 16px;
	}
}
</style>